import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: ReactNode;
  /** Small trail above the title, e.g. a link back to the parent page */
  breadcrumb?: ReactNode;
  /** Leading visual such as a project avatar */
  icon?: ReactNode;
  /** Muted text after the title, e.g. a result count */
  meta?: ReactNode;
  /** Right-aligned controls */
  actions?: ReactNode;
}

/** Shared page title row so every page has the same rhythm. */
export function PageHeader({ title, breadcrumb, icon, meta, actions }: PageHeaderProps) {
  return (
    <div className="mb-5">
      {breadcrumb && <div className="mb-1.5 text-sm text-gray-500">{breadcrumb}</div>}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          {icon}
          <h1 className="truncate text-2xl font-semibold text-gray-900">{title}</h1>
          {meta && <span className="shrink-0 text-sm text-gray-500">{meta}</span>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
